import { render } from "./UniteUsContent1.vue?vue&type=template&id=0cade625"
import script from "./UniteUsContent1.vue?vue&type=script&lang=js"
export * from "./UniteUsContent1.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__